<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs :crm_id="this.$route.params.crmid"/>
        <div class="table-agile-info">
          <div class="common-new-title mode2">
            <span>佣金列表</span>
            <router-link
              v-permission="[171]"
              class="icon-index-1 jm-fr"
              target="_blank"
              :to="{ name: 'financeCommissionAdd' }">
              <el-button
                type="primary"
                size="medium">创建佣金报账</el-button>
            </router-link>
          </div>
          <div class="searchList">
            <div class="box-content">
              <label class="form-tit">平台名称</label>
              <el-select
                class="jm-input280"
                v-model="searchData.project_id"
                clearable
                placeholder="请选择">
                <el-option label="芥末留学+前程日本" :value="1213"/>
                <el-option label="高考日语" :value="10"/>
                <el-option label="考培课程" :value="11"/>
              </el-select>
            </div>
            <div class="box-content">
              <label class="form-tit">合作方</label>
              <el-input
                v-model="searchData.partner_name"
                clearable
                class="jm-input280"/>
            </div>
            <div class="box-content">
              <label class="form-tit">发起人</label>
              <el-input
                v-model="searchData.creator_name"
                clearable
                class="jm-input280"/>
            </div>
            <div class="box-content">
              <label class="form-tit">费用类型</label>
              <el-select
                class="jm-input280"
                v-model="searchData.commission_kind"
                clearable
                placeholder="请选择">
                <el-option
                  v-for="item in selectDict.commission_type"
                  :label="item.value"
                  :key="item.id"
                  :value="item.id"/>
              </el-select>
            </div>
            <div class="box-content">
              <label class="form-tit">外币种类</label>
              <el-select
                class="jm-input280"
                v-model="searchData.currency_type"
                clearable
                placeholder="请选择">
                <el-option
                  v-for="item in selectDict.currency_type"
                  :label="item.value"
                  :key="item.id"
                  :value="item.id"/>
              </el-select>
            </div>
            <div class="box-content">
              <label class="form-tit">收款账户</label>
              <el-select
                class="jm-input280"
                v-model="searchData.payment_method"
                clearable
                placeholder="请选择">
                <el-option
                  v-for="item in selectDict.payment_method"
                  :label="item.value"
                  :key="item.id"
                  :value="item.id"/>
              </el-select>
            </div>
            <div class="box-content">
              <label class="form-tit">收款时间</label>
              <el-date-picker
                class="jm-input280"
                v-model="searchData.receive_time"
                clearable
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间">
              </el-date-picker>
            </div>
            <div class="box-content">
              <label class="form-tit">支付金额</label>
              <div style="display:inline-block;width:290px">
                <el-input
                  placeholder="起始金额"
                  class="jm-input135"
                  clearable
                  v-model="searchData.total_amount[0]">
                </el-input>
                <el-input
                  placeholder="结束金额"
                  class="jm-input135"
                  clearable
                  v-model="searchData.total_amount[1]">
                </el-input>
              </div>
            </div>
            <div class="box-content">
              <label class="form-tit">审核状态</label>
              <el-select
                class="jm-input280"
                v-model="searchData.finance_status"
                clearable
                placeholder="请选择">
                <el-option label="待补全" :value="-1"/>
                <el-option label="未确认" :value="0"/>
                <el-option label="审核通过" :value="1"/>
                <el-option label="已拒绝" :value="2"/>
              </el-select>
            </div>
            <!-- <div class="box-content">
                  <label class="form-tit">财务备注</label>
                  <el-input
                    v-model="searchData.finance_message"
                    class="jm-input280"/>
                </div> -->
            <div class="box-content">
              <label class="form-tit">到账日期</label>
              <el-date-picker
                class="jm-input280"
                v-model="searchData.verify_time"
                clearable
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </div>
            <div class="box-content box-content-double">
              <label class="form-tit">报账时间</label>
              <el-date-picker
                class="jm-input500"
                v-model="searchData.update_time"
                clearable
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间">
              </el-date-picker>
            </div>
          </div>
          <div class="searchBottom">
            <el-button
              class="jm-input-common3"
              type="primary"
              @click="() => this.$store.commit('updateRefresh', true)">搜索</el-button>
            <el-button
              class="jm-input-common3"
              type="default"
              @click="resetFields">重置</el-button>
            <el-button
              class="jm-input-common3"
              type="success"
              @click="exportDetails"
              :loading="btnLoading">导出明细</el-button>
          </div>
          <!--列表部分 start -->
          <jm-tableList
            :url="getListurl"
            :search-data="searchData"
          >
            <div name="perfix" slot="perfix" slot-scope="perfix" class="money-end-wrap">
              <a href="javascript:void(0)" @click="currencyUnit = Number(!currencyUnit)">
                <b v-if="currencyUnit">总额：{{ formatCurrency(perfix.data.totalAmount) }} 元</b>
                <b v-else>总额：{{ formatCurrency(perfix.data.totalAmount / 10000) }} 万元</b>
              </a>
            </div>
            <el-table-column
              slot="partner_name"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
            >
              <template slot-scope="scope">
                <el-popover
                  placement="top"
                  width="250"
                  trigger="hover">
                  {{ scope.row.partner_name }}
                  <span slot="reference" class="white-nowrap">{{ scope.row.partner_name }}</span>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
              slot="payment_method_str"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
            >
              <template slot-scope="scope">
                <el-popover
                  placement="top"
                  width="250"
                  trigger="hover">
                  {{ scope.row.payment_method_str }}
                  <span slot="reference" class="white-nowrap">{{ scope.row.payment_method_str }}</span>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
              slot="verify_message"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
            >
              <template slot-scope="scope">
                <el-popover
                  placement="top"
                  width="250"
                  trigger="hover">
                  {{ scope.row.verify_message }}
                  <span slot="reference" class="white-nowrap">{{ scope.row.verify_message }}</span>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
              slot="commission_memo"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
            >
              <template slot-scope="scope">
                <el-popover
                  placement="top"
                  width="250"
                  trigger="hover">
                  {{ scope.row.commission_memo }}
                  <span slot="reference" class="white-nowrap">{{ scope.row.commission_memo }}</span>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
              slot="finance_status_str"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
            >
              <template slot-scope="props">
                <el-tag :type="tagColors[props.row.finance_status]">{{ props.row.finance_status_str }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column slot="verify_time" label="到账日期">
              <a v-if="$hasPermission(171)" slot-scope="scope" @click="editVerifyTime(scope.row)" href="javascript:void(0)">
                {{ scope.row.verify_time }}
              </a>
              <template v-else>
                {{ scope.row.verify_time }}
              </template>
            </el-table-column>
            <el-table-column
              slot="finance_message"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
            >
              <template slot-scope="props">
                <el-tooltip popper-class="table-tooltip-area" effect="dark" :content="props.row.finance_message" placement="left">
                  <span>{{ props.row.finance_message }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              slot="lastColumn"
              fixed="right"
              align="center"
              header-align="center"
              width="200"
              label="操作">
              <template slot-scope="scope">
                <router-link
                  target="_blank"
                  :to="{ name: 'financeCommissionEdit', params: { id:scope.row.id }}">
                  <el-button type="primary" size="small">
                    {{ scope.row.finance_status === -1 ? '编辑' : '查看详情' }}
                  </el-button>
                </router-link>
                <el-button
                  type="warning"
                  :loading="btnLoading"
                  @click="showCommissionText(scope.row)"
                  size="small">报账文本</el-button>
                <br />
                <el-button
                  v-if="$hasPermission(171)"
                  type="success"
                  v-show="Number(scope.row.finance_status) === 0"
                  @click="verifyCommission(scope.row)"
                  size="small">审核确认</el-button>
                <el-button
                  v-if="$hasPermission(171)"
                  type="danger"
                  :loading="btnLoading"
                  v-show="Number(scope.row.finance_status) === 0"
                  @click="refuseCommission(scope.row)"
                  size="small">拒绝</el-button>
              </template>
            </el-table-column>
          </jm-tableList>
          <!--列表部分 end-->
        </div>

        <!--拒绝弹窗 start-->
        <el-dialog
          title="拒绝信息"
          :visible.sync="dialogRefuseLock"
          width="600px"
          :show-close="false">
          <el-form label-width="120px">
            <el-row>
              <el-col :span="24">
                <el-form-item label="财务备注：">
                  <el-input
                    type="textarea"
                    :rows="4"
                    resize="none"
                    placeholder="请输入内容"
                    v-model="verifyData.verifyMessage">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="info" @click="dialogRefuseLock = false">取 消</el-button>
            <el-button type="primary" :loading="btnLoading" @click="saveRefuseCommission">确 定</el-button>
          </span>
        </el-dialog>
        <!--拒绝弹窗 end-->

        <!--到账确认弹窗 start-->
        <el-dialog
          :title="onlyUpdateVerifyTime ? '修改到账时间' : '审核确认'"
          :visible.sync="dialogVerifyLock"
          width="600px"
          :show-close="false">
          <el-form label-width="120px">
            <el-row>
              <el-col :span="24">
                <el-form-item label="财务附件：" v-if="!onlyUpdateVerifyTime">
                  <jm-upload
                    class="upload-button display-inlineblock"
                    action="/newfib.php/finance/commission/uploadOnlineFile"
                    :file-list="verifyData.financeFile"
                    :on-preview="handelUploadPreview"
                    :on-remove="financeUploadRemove"
                    :on-success="financeUploadSuccess"
                    :show-file-list="true">
                    <el-button size="small" type="primary">上传文件</el-button>
                  </jm-upload>
                </el-form-item>
                <el-form-item label="到账日期：">
                  <el-date-picker
                    v-model="verifyData.verifyTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="info" @click="dialogVerifyLock = false">取 消</el-button>
            <el-button type="primary" :loading="btnLoading" :disabled="!verifyData.verifyTime" @click="saveVerifyDialog">确 定</el-button>
          </span>
        </el-dialog>
        <!--到账确认弹窗 start-->

        <!--报账文本弹窗 start-->
        <el-dialog
          title="报账内容"
          :visible.sync="dialogTextLock"
          width="600px"
          :show-close="false">
          <div style="white-space: pre-wrap; max-height: 400px; overflow-y: auto" v-html="commissionText"></div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" :loading="btnLoading" @click="dialogTextLock = false">确 定</el-button>
          </span>
        </el-dialog>
        <!--报账文本弹窗 end-->
      </div>
    </div>
    <!-- 图片预览 -->
    <el-dialog :visible.sync="fileImageDialogVisible" :width="fileImageWidth" :show-close="false" custom-class="imagePreview">
      <img :src="fileImageUrl" :title="fileImageName" width="100%" />
    </el-dialog>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs';
import tableList from '@/components/data/tableList';
import { formatCurrency, checkImageUrl } from '@/utils/utils';

const tagColors = {
  2: 'danger',
  1: 'success',
  0: 'warning',
};

export default {
  data() {
    return {
      tagColors,
      searchData: {
        partner_id: '',
        partner_name: '',
        creator_name: '',
        commission_kind: '',
        currency_type: '',
        project_id: '',
        payment_method: '',
        total_amount: ['', ''],
        finance_status: '',
        receive_time: [],
        update_time: [],
        verify_time: [],
      },
      getListurl: '/finance/commission/pagetable', // 表格数据源
      dialogRefuseLock: false, // 拒绝报账弹窗锁
      dialogVerifyLock: false, // 到账确认弹窗锁
      dialogTextLock: false, // 报帐文本弹窗锁
      commissionText: '', // 报帐文本
      selectDict: {}, // 下拉框字典
      onlyUpdateVerifyTime: false,
      verifyData: {
        id: 0,
        verifyTime: '', // 到账日期
        verifyMessage: '', // 审核备注
        financeStatus: 0, // 审核状态
        financeFile: [], // 财务附件
      },
      btnLoading: false,
      currencyUnit: 1, // 总额单位
      /* 图片预览 */
      fileImageDialogVisible: false,
      fileImageUrl: '',
      fileImageName: '',
      fileImageWidth: '65%'
    };
  },
  computed: {
  },
  methods: {
    financeUploadSuccess(response, file, fileList) {
      if (response.result === -1) {
        this.$message.error(response.msg);
        this.verifyData.financeFile = fileList.filter((f) => {
          return f.uid !== file.uid;
        });
      } else {
        this.verifyData.financeFile.push({
          url: response.data.url,
          name: response.data.name,
          path: response.data.path,
        });
      }
    },
    financeUploadRemove(file, fileList) {
      this.verifyData.financeFile = fileList;
    },
    handelUploadPreview(file) {
      if (!checkImageUrl(file.url)) {
        this.downloadFile(file);
      } else {
        this.previewImage(file);
      }
    },
    // 获取页面数据
    getPageData() {
      this.$http
        ._post({
          url: '/finance/commission/searchDs'
        })
        .then((res) => {
          this.selectDict = res.data;
        });
    },
    // 重置搜索
    resetFields() {
      Object.keys(this.searchData).forEach((k) => {
        this.searchData[k] = '';
      });
      this.searchData.total_amount = [];
      this.$store.commit('updateRefresh', true);
    },
    // 到账确认
    verifyCommission(row) {
      this.verifyData = {
        id: row.id,
        financeStatus: 1,
        financeFile: row.finance_file,
        verifyTime: '',
      };
      this.onlyUpdateVerifyTime = false;
      this.dialogVerifyLock = true;
    },
    // 修改到账时间
    editVerifyTime(row) {
      this.verifyData = {
        id: row.id,
        financeStatus: 1,
        verifyTime: row.verify_time,
      };
      this.onlyUpdateVerifyTime = true;
      this.dialogVerifyLock = true;
    },
    // 拒绝报账打开
    refuseCommission(row) {
      this.verifyData = {
        id: row.id,
        financeStatus: 2,
        verifyMessage: row.verify_message,
      };
      this.dialogRefuseLock = true;
    },
    // 到账提交保存
    saveVerifyDialog() {
      const url = '/finance/commission/verifyCommission';
      const msg = this.onlyUpdateVerifyTime ? '修改到账时间成功' : '审核确认操作成功';
      this.$http
        ._post({
          url: url,
          data: this.verifyData
        })
        .then(() => {
          this.$message.success(msg);
          this.dialogVerifyLock = false;
          this.$store.commit('updateRefresh', true);
        });
    },
    // 拒绝弹窗保存
    saveRefuseCommission() {
      this.$http
        ._post({
          url: '/finance/commission/verifyCommission',
          data: this.verifyData
        })
        .then(() => {
          this.$message.success('拒绝完成');
          this.dialogRefuseLock = false;
          this.$store.commit('updateRefresh', true);
        });
    },
    // 报帐文本
    showCommissionText(row) {
      this.commissionText = row.commission_text;
      this.dialogTextLock = true;
    },
    // 导出明细
    exportDetails() {
      this.btnLoading = true;
      this.$http
        ._post({
          url: '/finance/commission/downloadExcel',
          data: { searchData: this.searchData }
        })
        .then(({ data }) => {
          this.$http._download({
            filename: data,
            download: '佣金明细.xlsx'
          });
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    // 价格格式化
    formatCurrency(price) {
      return formatCurrency(price);
    },
    // 文件类型
    checkImageUrl(fileUrl) {
      return checkImageUrl(fileUrl);
    },
    // 下载文件
    downloadFile(file) {
      this.$message.success(`附件"${file.name}"下载完成`);
      this.$http.getFile({
        url: file.url,
        filename: file.name
      });
    },
    // 预览图片
    previewImage(file) {
      this.fileImageDialogVisible = true;
      this.fileImageName = file.name;
      this.fileImageUrl = file.url;
      this.fileImageWidth = '60%';
    }
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-tableList': tableList
  },
  mounted() {
    this.getPageData();
  }
};
</script>
<style scoped>
</style>
<style>
  .el-upload--picture-card{
    width: 120px;
    height: 120px;
    line-height: 118px;
  }
  .el-upload-list--picture-card .el-upload-list__item{
    width: 120px;
    height: 120px;
  }
  /* 图片预览 */
  .imagePreview .el-dialog__header {
    display: none;
  }
  .imagePreview .el-dialog__body {
    padding: 2px;
  }
</style>
